// The review fields the client reports with a decision — how the reviewer got
// to the document and how long it was on screen. The server
// (server/lib/reviewLog.js) validates the entry against its own list and caps
// the seconds; the client only reports. Every field is optional on the wire,
// so an older server ignores them and an older client sends none.
//
// Entries this app sends:
//   queue_edit    — /drafts row click or "ערוך ואשר"
//   approve_next  — arrived via the previous draft's "אשר והבא"
//   queue_quick   — the ✓ on the /drafts queue, timed from the queue's load
//                   or the reviewer's last decision there (stage 3 §1)
//   direct        — opened /document/:id some other way
//   upload_review — saved straight as non-draft from /upload's review stage
// (`approve_all` is set by the server; the client sends only the batch's
// seconds, timed like queue_quick, and the server shares them out.)

export const REVIEW_ENTRIES = Object.freeze(['queue_edit', 'approve_next', 'queue_quick', 'direct', 'upload_review']);

/** The entry carried in router state, falling back to the legacy autoEdit flag (from /drafts) or `direct`. */
export function reviewEntryFromState(state) {
  if (state && REVIEW_ENTRIES.includes(state.entry)) return state.entry;
  return state?.autoEdit === true ? 'queue_edit' : 'direct';
}

/** Whole seconds since `openedAt` (epoch ms), never negative; null when the open time is unknown. */
export function reviewSecondsSince(openedAt, now = Date.now()) {
  if (!Number.isFinite(openedAt)) return null;
  return Math.max(0, Math.round((now - openedAt) / 1000));
}

/** The `review` object a save carries: `{ opened_at, review_seconds, entry }`. */
export function buildReview({ openedAt, entry, now = Date.now() }) {
  return {
    opened_at: Number.isFinite(openedAt) ? new Date(openedAt).toISOString() : null,
    review_seconds: reviewSecondsSince(openedAt, now),
    entry,
  };
}
